import { IForgotPasswordInitialValues } from '../../../pages/Login/form';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { forgotPassword } from '../../../services/auth';

interface IProps {
  payload: IForgotPasswordInitialValues;
}

export const ThunkForgotPassword = createAsyncThunk<boolean, IProps>(
  `${storeResources.AUTH}/forgotPassword`,
  ({ payload }: IProps) => forgotPassword(payload).then(res => res.data),
);

export default {};
